import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ValidationContext } from './validationContext'
import { localized } from 'decorators'

const ValidationBoundary = React.memo(function ValidationBoundary ({ children, localize, locale }) {
  const [errors, setErrors] = useState([])

  const onValidate = React.useCallback((error, disabled) => {
    if (!disabled) { 
      const { field, errorMessage } = error
      const existingError = errors.find(x => x.field === field)
      if (existingError) {
        if (!errorMessage) {
          setErrors(errors.filter(x => x.field !== field))
        } else {
          setErrors(errors.map(e => e.field === field ? error : e))
        }
      } else {
        setErrors([ ...errors, error ])
      }
    }
  }, [errors])

  const clearErrors = React.useCallback((errorNames) => {
    setErrors(errors.filter(e => errorNames.indexOf(e.field) === -1))
  }, [errors])

  return (
    <ValidationContext.Provider value={{ errors, localize, locale, onValidate, clearErrors }}>
      {children}
    </ValidationContext.Provider>
  )
})

ValidationBoundary.propTypes = {
  children: PropTypes.node
}

export default localized(ValidationBoundary)
